import { render, staticRenderFns } from "./DeliveryRecordForm.vue?vue&type=template&id=5db16b24&scoped=true&"
import script from "./DeliveryRecordForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db16b24",
  null
  
)

export default component.exports